if (!customElements.get('wlsn-announcement-bar')) {
  class WLSNAnnouncementBar extends HTMLElement {
    constructor() {
      super();

      this.classes = {
        active: 'active',
        hidden: 'wlsn-hidden',
        swiperClass: 'js-announcement-bar-slider',
        prevButton: 'js-swiper-btn-prev',
        nextButton: 'js-swiper-btn-next',
        sectionId: `${this.getAttribute('data-section-id')}`,
      };

      this.lastScroll = window.scrollY;
    }
    
    /**
     * Get DOM elements
     * @returns {object} - Object containing DOM element references
     */
    get elements() {
      return {
        swiperElement: this.querySelector(`.${this.classes.swiperClass}`),
        prevButton: this.querySelector(`.${this.classes.prevButton}`),
        nextButton: this.querySelector(`.${this.classes.nextButton}`),
      };
    }

    /**
     * Connected callback lifecycle method
     * @returns {void}
     */
    connectedCallback() {
      this._initializeSwiper();
      this._setAnnouncementBarHeight();
      window.matchMedia('(max-width: 1023px)').addEventListener('change', this._setAnnouncementBarHeight.bind(this));
      window.addEventListener('scroll', this._handleScroll.bind(this));
    }

    /**
     * Disconnected callback lifecycle method
     * @returns {void}
     */
    disconnectedCallback() {
      window.removeEventListener('scroll', this._handleScroll);
    }

    /**
     * Initialize Swiper carousel
     * @returns {void}
     */
    _initializeSwiper() {
      const settingsElement = document.getElementById(`CarouselSettings-${this.classes.sectionId}`);
      const settings = JSON.parse(settingsElement.textContent);

      this.swiper = new Swiper(this.elements.swiperElement, {
        loop: settings.loop,
        spaceBetween: 12,
        slidesPerView: 1,
        pagination: false,
        autoplay: {
          delay: settings.animationSpeed || 3000,
          enabled: settings.autoplay,
        },

        navigation: {
          prevEl: this.elements.prevButton ?? null,
          nextEl: this.elements.nextButton ?? null,
          enabled: true,
        },
      });
    }

    /**
     * Handle scroll event to update announcement bar height
     * @returns {void}
     */
    _handleScroll() {
      const currentScroll = window.scrollY;
      const announcementBarHeight = currentScroll > this.offsetHeight ? 0 : this.offsetHeight;
      const rootFontSize = parseFloat(getComputedStyle(document.documentElement).fontSize) || 16;
      const announcementBarHeightRem = announcementBarHeight / rootFontSize;
      document.documentElement.style.setProperty('--wlsn-announcement-bar-height', `${announcementBarHeightRem}rem`);
      this.lastScroll = currentScroll;
    }

    /**
     * Set announcement bar height CSS variable
     * @returns {void}
     */
    _setAnnouncementBarHeight() {
      const announcementBarHeight = this.offsetHeight;
      const rootFontSize = parseFloat(getComputedStyle(document.documentElement).fontSize) || 16;
      const announcementBarHeightRem = announcementBarHeight / rootFontSize;
      document.documentElement.style.setProperty('--wlsn-announcement-bar-height', `${announcementBarHeightRem}rem`);
    }
  }

  window.customElements.define('wlsn-announcement-bar', WLSNAnnouncementBar);
}
